import React, { useState, useCallback } from 'react';
import { Marker } from '@react-google-maps/api';
import useLongPress from '../CustomHooks/useLongPress';

const getCustomMapPinIcon = (hexColor = '#FF0000', isDragging = false) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${isDragging ? 40 : 32}" height="${
    isDragging ? 40 : 32
  }" fill="${hexColor}">
      <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd"/>
    </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const RenderPins = ({ pins, setPins, setSelected, onUpdatePin }) => {
  const [draggingPinId, setDraggingPinId] = useState(null);

  const { start, cancel, wasLongPress, shouldBlockDrag } = useLongPress(
    useCallback(({ pinId }) => {
      setDraggingPinId(pinId);
    }, []),
  );

  const handlePinDragEnd = useCallback(
    async (e, pin) => {
      const updatedPin = {
        ...pin,
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng(),
      };

      // Optimistic local update
      setPins(prev => prev.map(p => (p.id === pin.id ? updatedPin : p)));
      setDraggingPinId(null);

      try {
        await onUpdatePin?.(updatedPin);
      } catch (err) {
        console.error('Failed to update pin position:', err);
        setPins(prev => prev.map(p => (p.id === pin.id ? pin : p))); // rollback
      }
    },
    [setPins, onUpdatePin],
  );

  return (
    <>
      {pins.map(pin => {
        const isDragging = draggingPinId === pin.id;

        return (
          <Marker
            key={pin.id}
            position={{ lat: pin.latitude, lng: pin.longitude }}
            draggable={true}
            icon={{
              url: getCustomMapPinIcon(pin.hexColor, isDragging),
              scaledSize: new window.google.maps.Size(isDragging ? 40 : 32, isDragging ? 40 : 32),
            }}
            onMouseDown={() => start({ pinId: pin.id })}
            onMouseUp={cancel}
            onDragStart={e => {
              if (shouldBlockDrag()) e.stop();
            }}
            onDragEnd={e => {
              if (!wasLongPress()) return;
              handlePinDragEnd(e, pin);
            }}
            onClick={() => {
              if (wasLongPress()) return;
              setSelected(pin);
            }}
            options={{ zIndex: isDragging ? 1000 : 1 }}
          />
        );
      })}
    </>
  );
};

export default RenderPins;
